<script>
import formInput from "@/mixins/shared/formInput";
import Checkbox from "@/pages/components/form/horizontal/checkbox.vue";
import MultipleChecks from "@/mixins/shared/multipleChecks";
import MultipleChecksProps from "@/mixins/shared/multipleChecksProps";

export default {
	mixins: [formInput, MultipleChecks, MultipleChecksProps],
	components: {Checkbox},
	methods: {
		isChecked(option) {
			return this.modelValue.includes(this.optionValue(option));
		}
	}
}
</script>

<template>
	<div class="d-flex column-gap-3 row-gap-2" :class="{'flex-column' : layout === 'vertical'}">
		<Checkbox
			v-bind="$attrs"
			v-for="(option, index) in renderedOptions"
			:key="index"
			:model-value="modelValue"
			:form="form"
			:name="name"
			:id="`${this.renderedId}-${index}`"
			:value="optionValue(option)"
			:label="optionLabel(option)"
			:checked="isChecked(option)"
			@update:modelValue="$emit('update:modelValue', $event)"
		>
			<div v-if="$slots.descriptionbottom" class="input-description mt-2">
				<slot name="descriptionbottom" />
			</div>
		</Checkbox>
	</div>
</template>